"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _get = _interopRequireDefault(require("lodash/get"));
var _APIcon = _interopRequireDefault(require("../common/APIcon"));
var _config = _interopRequireDefault(require("../../config"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
require("./PageFooterComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var pageFooterClasses = (0, _cssClassesHelper.getBEMClasses)('page-footer');
var PageFooterComponent = function PageFooterComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("footer", {
    className: pageFooterClasses()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: pageFooterClasses('footer-left-content')
  }, t("{{n}}™ {{y}}. All Rights Reserved.", {
    n: _config["default"].Footer.siteName || _config["default"].global.siteName,
    y: new Date().getFullYear()
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: pageFooterClasses('footer-right-content')
  }, (0, _get["default"])(_config["default"], 'Footer.links', []).map(function (column, idx) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: idx,
      className: pageFooterClasses('text')
    }, column.map(function (item, innerIdx) {
      var openInNewWindow = _config["default"].Footer.openInNewWindowGlobal || true;
      if ('openInNewWindow' in item) {
        openInNewWindow = item.openInNewWindow;
      }
      return /*#__PURE__*/_react["default"].createElement("a", {
        target: openInNewWindow ? '_blank' : '',
        rel: openInNewWindow ? 'noopener noreferrer' : '',
        key: "".concat(idx).concat(innerIdx),
        href: item.link
      }, t(item.text));
    }));
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: pageFooterClasses('icon')
  }, !_config["default"].Footer.powerOff && /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
    name: "logo-powered"
  }))));
};
var _default = exports["default"] = PageFooterComponent;